import axios from 'axios'

const API_BASE = process.env.VUE_APP_AFFILIATE_API_URL || ''

export const api = axios.create({
  baseURL: API_BASE,
})

// Attach token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('affiliate_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle 401/403 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Only redirect if not already on login page to avoid disrupting login attempts
      if (window.location.pathname !== '/login') {
        localStorage.removeItem('affiliate_token')
        localStorage.removeItem('affiliate_email')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)
